import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import './ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Construir el cuerpo del correo
    const mailBody = `
Nombre: ${formData.name}
Email: ${formData.email}
Teléfono: ${formData.phone}

Mensaje:
${formData.message}
    `.trim();

    // Crear el enlace de Gmail
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=megnasa21@gmail.com&su=${encodeURIComponent(`Mensaje de contacto de ${formData.name}`)}&body=${encodeURIComponent(mailBody)}`;
    
    // Abrir Gmail en una nueva pestaña
    window.open(gmailUrl, '_blank');
    
    // Opcional: Limpiar el formulario después del envío
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div className="contact-container">
      <h1></h1>
      
      <div className="contact-card">
        <div className="contact-grid">
          {/* Left Side - Contact Info */}
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p className="contact-desc">
              Fill out the form and we will get back to you within 24 hours.
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <Phone className="icon" />
                <span>+52 618 824 6172</span>
              </div>
              <div className="contact-item">
                <Mail className="icon" />
                <span>megnasa21@gmail.com</span>
              </div>
              <div className="contact-item">
                <MapPin className="icon" />
                <span>Durango, México</span>
              </div>
            </div>

            <div className="map-placeholder">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58302.70144715295!2d-104.6562962074707!3d24.0339269832418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x869bb7a518bcdf73%3A0xbfdd8ea63a6c4ad4!2sDurango%2C%20Dgo.!5e0!3m2!1ses-419!2smx!4v1733085783592!5m2!1ses-419!2smx"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '0.5rem' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="decorative-circles">
              <div className="circle circle-1"></div>
              <div className="circle circle-2"></div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div className="form-fields">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  required
                />
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>

              <button type="submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;